<loading-bar></loading-bar>
<div class="flex flex-col h-full">
  @if (sessionDegraded()) {
    <!--
      Băng "phiên suy giảm" là phần tử ĐẦU TIÊN của tài liệu, nên trong PWA đã cài trên iOS
      (viewport-fit=cover + status bar black-translucent) nó nằm LỌT dưới thanh trạng thái:
      chữ của nó chen vào vùng tai thỏ, cạnh đồng hồ của hệ điều hành (báo 18/08).

      Đệm trên phải cộng thêm vùng an toàn. Cố ý dùng `pb-1.5` chứ KHÔNG `py-1.5`:
      `tailwind.config.js` bật `important: true`, nên `.py-1.5` sinh ra
      `padding-top: 6px !important` và sẽ THẮNG thuộc tính style nội tuyến không-important
      ở đây — đúng lỗi đã làm mọi drawer bị canh giữa hồi tháng 7. Không có class nào đặt
      padding-top thì nội tuyến mới có tác dụng.

      `var(--m-safe-top, …)` để dùng chung một nguồn với shell mobile (nơi JS ghi đè biến này
      khi hệ điều hành ĐÃ chừa sẵn vùng an toàn); ngoài shell thì rơi về `env()` như thường.
    -->
    <div
      class="flex items-center justify-center gap-2 px-4 pb-1.5 bg-amber-50 border-b border-amber-200 text-amber-800 text-token-caption dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-300"
      style="padding-top: calc(6px + var(--m-safe-top, env(safe-area-inset-top, 0px)))"
      role="alert"
    >
      <span class="material-symbols-outlined icon-size-token-sm">sync_problem</span>
      <span>{{ 'Auth.SessionDegraded' | translate }}</span>
    </div>
  }
  <!-- `overflow-x-auto` (thay cho `overflow-hidden` cũ): shell desktop có min-width
       1024px, dưới ngưỡng đó phải CUỘN NGANG chứ không bị cắt cụt. -->
  <div class="flex-grow overflow-x-auto overflow-y-hidden">
    @if (layout === 'admin') {
      <admin-layout></admin-layout>
    }

    @if (layout !== 'admin') {
      <div class="w-full h-full overflow-hidden">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
